import {
  RESET_SELECTED_PVZ,
  SET_RECENT_DIALOG,
  SET_USER_AUTH,
  SOCKET_CONNECTED,
  SET_SELECTED_PVZ,
  SET_USER_NEW_ORDER,
  SET_CAR_BRANDS,
  MESSAGE_UNBLOCK,
  MESSAGE_BLOCK,
  SET_OPEN_KEYBOARD,
  AUTH_REQUEST,
  LOGOUT,
  TOGGLE_AUTH_MODAL,
  TOGGLE_LOGOUT_MODAL,
  SET_AUTH_CODE_IS_VALID,
  RESET_AUTH_CODE_IS_VALID,
  SET_ORDERS,
  PHONE_REQUEST_AUTH_FAILED,
  SET_CURRENT_MOBILE_LAYOUT,
  SET_ARCHIVE_DIALOG_FIXED
} from '../actions/meta';

export const metaInitialState = {
  socket: {
    isConnected: false,
  },
  user: {
    visitorId: null,
    dialogId: null,
  },
  isMessageBlocked: true,
  selectedPvz: {},
  carBrands: [],
  isKeyboardOpen: false,
  orders: [],
  auth: {
    isPhoneAuthRequestFailed: false,
    isAuthModalOpen: false,
    isAuthCodeValid: true,
    isLogoutModalOpen: false,
    phone: null,
    code: null,
    logout: null
  },
  currentMobileLayout: 'chat',
  isArchiveDialogFixed: false,
  userNewOrderCount: 0,
};

const metaActions = (state = metaInitialState, { type, result, payload }) => {
  switch (type) {
    case SOCKET_CONNECTED:
      return {
        ...state,
        socket: {
          ...state.socket,
          isConnected: true,
        },
      };

    case SET_USER_AUTH:
      if (result.resetLogout) {
        state = { ...state, auth: { ...state.auth, logout: null } };
      }
      state = { ...state, user: result };
      return state;

    case SET_RECENT_DIALOG:
      return {
        ...state,
        user: {
          ...state.user,
          dialogId: result.dialogId,
        },
      };

    case SET_SELECTED_PVZ:
      return { ...state, selectedPvz: payload };

    case RESET_SELECTED_PVZ:
      return { ...state, selectedPvz: metaInitialState.selectedPvz };

    case SET_CAR_BRANDS:
      return { ...state, carBrands: result && result.data ? result.data.carBrands : [] };

    case SET_ORDERS:
      return { ...state, orders: result && result.data && result.data.buyerDeliveryOrders ? result.data.buyerDeliveryOrders.orders : [] };

    case MESSAGE_UNBLOCK:
      return { ...state, isMessageBlocked: false };

    case MESSAGE_BLOCK:
      return { ...state, isMessageBlocked: true };

    case SET_OPEN_KEYBOARD:
      return { ...state, isKeyboardOpen: payload };

    case AUTH_REQUEST:
      return { ...state, auth: { ...state.auth, phone: payload.phone, code: payload.code } };

    case LOGOUT:
      state = { ...state, auth: { ...state.auth, phone: null, code: null, logout: true } };
      return state;

    case TOGGLE_AUTH_MODAL:
      let updatedAuth = { ...state.auth, isPhoneAuthRequestFailed: false, isAuthModalOpen: payload };
      return { ...state, auth: updatedAuth };

    case TOGGLE_LOGOUT_MODAL:
      return { ...state, auth: { ...state.auth, isLogoutModalOpen: payload } };

    case SET_AUTH_CODE_IS_VALID:
      if (result.success) {
        state = { ...state, auth: { ...state.auth, isAuthModalOpen: false } };
      }
      state = { ...state, auth: { ...state.auth, isAuthCodeValid: result.success, authCodeErrorMessage: result.message } };
      return state;

    case RESET_AUTH_CODE_IS_VALID:
      return { ...state, auth: { ...state.auth, isAuthCodeValid: true, authCodeErrorMessage: null } };

    case PHONE_REQUEST_AUTH_FAILED:
      return { ...state, auth: { ...state.auth, isPhoneAuthRequestFailed: true } };

    case SET_CURRENT_MOBILE_LAYOUT:
      sessionStorage.setItem('layoutValue', payload);
      return { ...state, currentMobileLayout: payload };

    case SET_ARCHIVE_DIALOG_FIXED:
      return { ...state, isArchiveDialogFixed: payload };

    case SET_USER_NEW_ORDER:
      return { ...state, userNewOrderCount: ++state.userNewOrderCount };

    default:
      return state;
  }
};

export default metaActions;
